import { p as prisma } from "../../../../../chunks/prisma.js";
import { fail } from "@sveltejs/kit";
import { b as validateProduct } from "../../../../../chunks/index4.js";
import { unlink, mkdir, writeFile } from "node:fs/promises";
import { dirname } from "node:path";
const load = (async ({ params, depends }) => {
  depends("update:product");
  const id = Number(params.id);
  try {
    const productPromise = prisma.product.findUnique({
      where: { id },
      include: {
        Image: { select: { url: true } },
        categories: { select: { id: true, name: true } }
      }
    });
    const categoriesPromise = prisma.category.findMany({ orderBy: { sortOrder: "asc" } });
    const productDocumentsPromise = prisma.productDocument.findMany({
      where: { productId: id },
      select: { id: true, originalName: true, sizeBytes: true },
      orderBy: { sortOrder: "asc" }
    });
    const [product, categories, productDocuments] = await Promise.all([
      productPromise,
      categoriesPromise,
      productDocumentsPromise
    ]);
    if (!product) return { status: 404, error: "Product not found" };
    return { success: true, product, categories, productDocuments };
  } catch (e) {
    console.log("getProduct:", e);
    return { status: 500, error: "Internal server error getting product details" };
  }
});
const actions = {
  default: async ({ request, params }) => {
    const id = Number(params.id);
    const formData = await request.formData();
    const formObj = {};
    for (const pair of formData) {
      const [k, v] = pair;
      formObj[k] = v;
    }
    const parsedData = {
      ...formObj,
      price: formObj.price ? parseFloat(formObj.price) : void 0,
      quantity: formObj.quantity ? parseInt(formObj.quantity) : void 0,
      pageCount: formObj.pageCount ? parseInt(formObj.pageCount) : void 0,
      digitalCopyPrice: formObj.digitalCopyPrice ? parseFloat(formObj.digitalCopyPrice) : void 0,
      categoryIds: formData.getAll("categoryIds").map((id2) => parseInt(id2)),
      publicationDate: formObj.publicationDate ? parseInt(formObj.publicationDate) : void 0,
      citation: formObj.citation || void 0,
      isbn: formObj.isbn || void 0
    };
    const validation = validateProduct(parsedData);
    if (!validation.success) {
      return fail(400, {
        data: formObj,
        errors: validation.errors
      });
    }
    const {
      name,
      description,
      price,
      quantity,
      digitalCopyPrice,
      author,
      citation,
      isbn,
      publicationDate: publicationDateData,
      pageCount,
      categoryIds
    } = validation.data;
    const publicationDate = publicationDateData ? new Date(publicationDateData) : void 0;
    const serviceCode = Math.floor(Math.random() * 87654321).toString();
    const newImage = formData.get("newImage");
    let imageUrl;
    if (newImage && newImage.name) {
      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!allowedTypes.includes(newImage.type)) {
        return fail(400, {
          data: formObj,
          errors: { _errors: ["Invalid image type"] }
        });
      }
      const existingImages = await prisma.image.findMany({
        where: { productId: id }
      });
      for (const img of existingImages) {
        const oldFilePath = `uploads/images/${img.url.split("/").pop()}`;
        unlink(oldFilePath).catch((e) => console.log(`Old image not found or not removed: ${oldFilePath}
 ${e}`));
        await prisma.image.delete({
          where: { id: img.id }
        });
      }
      const fileName = `${Date.now()}-${newImage.name}`;
      const imagePath = `uploads/images/${fileName}`;
      const directory = dirname(imagePath);
      await mkdir(directory, { recursive: true });
      await writeFile(imagePath, new Uint8Array(await newImage.arrayBuffer()));
      imageUrl = `/api/image/${fileName}`;
    }
    try {
      const existing = await prisma.product.findUnique({ where: { serviceCode } });
      if (existing && existing.id !== id) {
        return fail(400, {
          data: formObj,
          errors: { _errors: ["Product with this service code already exists"] }
        });
      }
      const cats = await prisma.category.findMany({ where: { id: { in: categoryIds } } });
      if (cats.length !== categoryIds.length) {
        return fail(400, {
          data: formObj,
          errors: { categoryIds: ["Invalid category IDs"] }
        });
      }
      const product = await prisma.product.update({
        where: { id },
        data: {
          name,
          description,
          price,
          digitalCopyPrice: typeof validation.data.digitalCopyPrice === "number" ? validation.data.digitalCopyPrice : void 0,
          serviceCode,
          author,
          citation,
          ISBN: isbn,
          publicationDate,
          pageCount,
          categories: { set: categoryIds.map((id2) => ({ id: id2 })) },
          ...imageUrl ? {
            Image: {
              create: { url: imageUrl }
            }
          } : {}
        }
      });
      return { success: true, product };
    } catch (e) {
      console.log("editProd error: ", e);
      return fail(500, { errors: { _errors: ["Internal server error updating product"] } });
    }
  }
};
export {
  actions,
  load
};
